import { ErrorBoundary, FailureState } from "@dealer-center/core-errors";
import { NewRelic } from "@dealer-center/core-third-party-newrelic";
import { LaunchDarkly } from "./LaunchDarkly";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useAppRoutes } from "./Routes";

export function App() {
  const router = createBrowserRouter(useAppRoutes(), {
    basename: "/landing"
  });

  return (
    <LaunchDarkly>
      <ErrorBoundary
        FallbackComponent={FailureState}
        onError={NewRelic.handleError}
      >
        <RouterProvider router={router} />
      </ErrorBoundary>
    </LaunchDarkly>
  );
}

export default App;
